import { render, staticRenderFns } from "./report.vue?vue&type=template&id=6b4f7e1c&scoped=true&"
import script from "./report.vue?vue&type=script&lang=ts&"
export * from "./report.vue?vue&type=script&lang=ts&"
import style0 from "./report.vue?vue&type=style&index=0&id=6b4f7e1c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4f7e1c",
  null
  
)

export default component.exports